export default __webpack_public_path__ + "static/media/yt.f5c7efef.png";